// Shared play icon — replaces the "▶" text character everywhere in the UI.
// On iPhone, U+25B6 (▶) renders as a blue emoji glyph in a box instead of a
// plain triangle, which looks broken next to our own colours/sizing. An SVG
// triangle (fill: currentColor) always matches the surrounding text/icon
// colour and never falls back to emoji rendering.
//
// PlayIcon  — the bare triangle, for inline labels ("▶ Watch", "▶ PLAYING · FROM…").
// PlayBadge — the circular white button used over thumbnails/covers.

export default function PlayIcon({ size = 14, color = "currentColor", style }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true" style={style}>
      <path d="M7 4.5v15l13-7.5-13-7.5z" fill={color}/>
    </svg>
  );
}

export function PlayBadge({ size = 40, triangleColor = "var(--ink)" }) {
  return (
    <span style={{
      width: size, height: size, borderRadius: size / 2,
      background: "rgba(255,255,255,0.92)", boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
      display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
    }}>
      {/* Nudged 1px right — an equilateral triangle's visual centroid sits
          left of its bounding box's true center, so a dead-center SVG reads
          as slightly off; small manual correction, same trick used for play
          buttons generally. */}
      <PlayIcon size={Math.round(size * 0.4)} color={triangleColor} style={{ marginLeft: 1 }}/>
    </span>
  );
}
